import React from "react";
import ReactDOM from "react-dom/client";

// Webfont self-hosted: servirli dal CDN di Google trasmetterebbe l'IP di ogni
// visitatore a Google prima di qualsiasi consenso (art. 122 D.Lgs 196/2003).
import "@fontsource/outfit/300.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/cormorant-garamond/300.css";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/300-italic.css";
import "@fontsource/cormorant-garamond/400-italic.css";
import "@fontsource/inter/600.css";

import "@/index.css";
import App from "@/App";
import { initConsent } from "@/lib/consent";

// Riattiva solo ciò che l'utente aveva già autorizzato in una visita
// precedente. Non attiva nulla di propria iniziativa.
initConsent();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
